import moment from "moment";

class PDFTimesheetReport {
    constructor() {
        this.reportData = null;
        this.summaryPages = [];
    }


    async previewPDF(data, containerId = "pdf-preview") {
        this.reportData = data;

        await this.waitForPdfMakeReady();

        this.summaryPages = [];
        const docDefinition = this.buildDocDefinition();

        const pdfDoc = pdfMake.createPdf(docDefinition);
        pdfDoc.getBuffer(() => {

            console.log(this.summaryPages);

            pdfDoc.getDataUrl((dataUrl) => {
                const iframe = document.getElementById(containerId);

                if (!iframe) {
                    console.error("ไม่พบ container PDF preview");
                    return;
                }

                iframe.src = dataUrl;
            });
        });

    }

    async exportToPDF(data) {
        this.reportData = data;

        await this.waitForPdfMakeReady();

        const docDefinition = this.buildDocDefinition();

        pdfMake.createPdf(docDefinition).open();
    }

    waitForPdfMakeReady() {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (typeof pdfMake !== "undefined" && pdfMake.fonts) {
                    clearInterval(interval);
                    resolve(true);
                }
            }, 100);
        });
    }

    // ================= UTIL =================

    formatDate(date) {
        if (!date) return "";

        return moment(date).format("DD/MM/YYYY");
    }

    formatHour(value) {
        return Number(value || 0).toFixed(1);
    }

    // ================= CLIENT NAME =================

    getClientNameByPage(currentPage) {
        const clients = this.reportData?.clients || [];

        let currentClient = "";

        let startPage = 1;

        clients.forEach((client) => {

            if (currentPage >= startPage) {
                currentClient = client.client_name;
            }

            const itemCount = client.items?.length || 0;

            const estimatedPages =
                Math.max(
                    1,
                    Math.ceil(itemCount / 18)
                );

            startPage += estimatedPages;
        });

        return currentClient;
    }

    // ================= PAGE HEADER =================

    buildPageHeader(currentPage) {
        const header = this.reportData?.header || {};

        return {
            margin: [35, 18, 35, 0],

            columns: [

                // ================= LEFT =================

                {
                    width: "55%",

                    stack: [
                        {
                            text:
                                header.company_name_en || " ",

                            bold: true,

                            fontSize: 15,
                        },

                        {
                            text: header.inv_company_sub_name || " ",

                            bold: true,

                            fontSize: 8,

                            margin: [0, 1, 0, 0],
                        },

                        {
                            text:
                                header.company_name_th || " ",

                            bold: true,

                            fontSize: 12,

                            margin: [0, 2, 0, 0],
                        },
                        {
                            text: [
                                {
                                    text: "Client Name: ",
                                    bold: true,
                                },
                                {
                                    text: `${this.getClientNameByPage(currentPage)}`,
                                    bold: true,
                                }
                            ],
                            fontSize: 10,
                            margin: [0, 30, 0, 2],
                        }
                    ],
                },

                // ================= RIGHT =================

                {
                    width: "45%",

                    stack: [
                        {
                            text: [

                                {
                                    text: "Client Timesheet Report",

                                    bold: true,
                                },
                            ],

                            alignment: "right",

                            fontSize: 13,
                        },

                        {
                            text:
                                `Period: ${this.formatDate(
                                    header.date_from
                                )} - ${this.formatDate(header.date_to)}`,

                            alignment: "right",

                            bold: true,

                            fontSize: 9,

                            margin: [0, 5, 0, 0],
                        },

                        {
                            text:
                                `Issued Date: ${this.formatDate(
                                    header.issue_date
                                )}`,

                            alignment: "right",

                            bold: true,

                            fontSize: 9,

                            margin: [0, 2, 0, 0],
                        },

                    ],
                },
            ],

            canvas: [
                {
                    type: "line",

                    x1: 0,
                    y1: 72,

                    x2: 525,
                    y2: 72,

                    lineWidth: 0.7,
                },
            ],
        };
    }

    // ================= DETAIL =================

    buildDetailText(item) {
        const isNC =
            (item.chargetype || "").trim().toUpperCase() === "N/C";

        return [
            {
                text: item.detail || "",
                noWrap: false,
                preserveLeadingSpaces: false,
            },
            ...(item.chargetype
                ? [
                    {
                        text: ` (${item.chargetype})`,
                        color: isNC ? "red" : "black",
                    },
                ]
                : []),
        ];
    }


    // ================= CLIENT SECTION =================

    buildClientSection(client) {


        const items = client?.items || [];

        const body = [];

        const grouped = {};

        // ================= GROUP =================

        items.forEach((item) => {

            const key = item.assignment || "-";

            if (!grouped[key]) {
                grouped[key] = [];
            }

            grouped[key].push(item);
        });

        // ================= TABLE HEADER =================

        body.push([
            {
                stack: [
                    {
                        text: "Assignment",

                        bold: true,

                        fontSize: 9,

                        alignment: "left",

                        margin: [10, 9, 0, 9],
                    },

                ],

                border: [true, true, true, true],
            },

            {
                stack: [

                    {
                        text: "Date",

                        bold: true,

                        fontSize: 9,

                        alignment: "center",

                        margin: [0, 9, 0, 9],
                    },


                ],

                border: [true, true, true, true],
            },

            {
                stack: [

                    {
                        text: "Case Worker",

                        bold: true,

                        fontSize: 9,

                        alignment: "center",

                        margin: [0, 9, 0, 9],
                    },

                ],
                border: [true, true, true, true],
            },

            {
                stack: [

                    {
                        text: "Details",

                        bold: true,

                        fontSize: 9,

                        alignment: "left",

                        margin: [8, 9, 0, 9],

                    },

                ],
                border: [true, true, true, true],
            },

            {
                stack: [

                    {
                        text: "Hour",

                        bold: true,

                        alignment: "right",

                        fontSize: 9,

                        margin: [0, 9, 10, 9],

                    },

                ],
                border: [true, true, true, true],
            },
        ]);

        // ================= ASSIGNMENT =================

        Object.keys(grouped).forEach((assignment) => {

            // ================= TITLE =================

            body.push([
                {
                    text: assignment,

                    bold: true,

                    fontSize: 10,

                    alignment: "left",

                    margin: [10, 16, 0, 6],

                    border: [true, false, true, false],
                },

                {
                    text: "",

                    border: [true, false, true, false],
                },

                {
                    text: "",

                    border: [true, false, true, false],
                },

                {
                    text: "",

                    border: [true, false, true, false],
                },

                {
                    text: "",

                    border: [true, false, true, false],
                },
            ]);

            // ================= ITEMS =================

            grouped[assignment].forEach((item, index, arr) => {


                body.push([

                    // ================= ASSIGNMENT EMPTY =================

                    {
                        text: "",

                        margin: [0, 0, 0, 10],

                        border: [
                            true,
                            false,
                            true,
                            true
                        ],
                    },

                    // ================= DATE =================

                    {
                        text: this.formatDate(item.date),

                        alignment: "center",

                        fontSize: 9,

                        margin: [0, 0, 0, 10],

                        border: [
                            true,
                            false,
                            true,
                            true
                        ],
                    },

                    // ================= CASE WORKER =================

                    {
                        text: item.case_worker || "",

                        alignment: "center",

                        fontSize: 9,

                        margin: [0, 0, 0, 10],

                        border: [
                            true,
                            false,
                            true,
                            true
                        ],
                    },

                    // ================= DETAIL =================

                    {
                        text: this.buildDetailText(item),

                        alignment: "left",

                        fontSize: 9,

                        lineHeight: 1.25,

                        margin: [8, 0, 12, 10],

                        border: [
                            true,
                            false,
                            true,
                            true
                        ],
                    },

                    // ================= HOUR =================

                    {
                        text: this.formatHour(item.hour),

                        alignment: "right",

                        fontSize: 9,

                        margin: [0, 0, 10, 10],

                        border: [
                            true,
                            false,
                            true,
                            true
                        ],
                    },
                ]);
            });
        });

        return {
            table: {
                headerRows: 1,
                widths: [125, 75, 70, 205, 45],
                body,
            },

            layout: {
                defaultBorder: false,

                hLineWidth: function (i, node) {
                    const isHeaderTop = i === 0;
                    const isHeaderBottom = i === 1;

                    if (isHeaderTop || isHeaderBottom) return 1;

                    const isBottomLine = i === node.table.body.length;

                    if (isBottomLine) return 1;

                    return 0;
                },


                vLineWidth: () => 1,

                hLineColor: () => "#000",
                vLineColor: () => "#000",

                paddingLeft: () => 0,
                paddingRight: () => 0,
                paddingTop: () => 0,
                paddingBottom: () => 0,
            },

            margin: [0, 0, 0, 18],

            // ================= 🔥 ADD THIS (ONLY FIX) =================
            // วาดเส้นล่างของ "ทั้ง block table" ไม่สน page break
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 0,
                    x2: 515, // width A4 usable area
                    y2: 0,
                    lineWidth: 1,
                },
            ],
        };
    }

    // ================= SUMMARY =================

    buildSummary(client) {
        const items = client?.items || [];

        let chargedHour = 0;
        let nonChargeHour = 0;

        items.forEach((item) => {

            const hour = Number(item.hour || 0);

            const isNC =
                (item.chargetype || "").trim().toUpperCase() === "N/C";

            if (isNC) {
                nonChargeHour += hour;
            } else {
                chargedHour += hour;
            }
        });

        const totalHour = chargedHour + nonChargeHour;

        return {
            id: "summary-section",
            unbreakable: true,
            columns: [
                { width: "*", text: "" },

                {
                    width: 190,
                    margin: [0, 20, 0, 0],
                    stack: [

                        // ================= CHARGED =================
                        {
                            columns: [
                                {
                                    width: "*",
                                    text: "Charged Hour",
                                    alignment: "right",
                                    fontSize: 9,
                                },
                                {
                                    width: 55,
                                    text: this.formatHour(chargedHour),
                                    alignment: "right",
                                    fontSize: 9,
                                },
                            ],
                        },

                        // ================= NON CHARGED =================
                        {
                            columns: [
                                {
                                    width: "*",
                                    text: "Non-Charge Hour (N/C)",
                                    alignment: "right",
                                    color: "red",
                                    fontSize: 9,
                                    margin: [0, 3, 0, 0],
                                },
                                {
                                    width: 55,
                                    text: this.formatHour(nonChargeHour),
                                    alignment: "right",
                                    color: "red",
                                    fontSize: 9,
                                    margin: [0, 3, 0, 0],
                                },
                            ],
                        },

                        // ================= LINE =================
                        {
                            columns: [
                                {
                                    width: "*",
                                    text: "___",
                                    alignment: "right",
                                    fontSize: 9,
                                    margin: [0, 0, 0, 3],
                                },
                                {
                                    width: 55,
                                    text: "___",
                                    alignment: "right",
                                    fontSize: 9,
                                    margin: [0, 0, 0, 3],
                                },
                            ],
                        },

                        // ================= TOTAL =================
                        {
                            columns: [
                                {
                                    width: "*",
                                    text: "Total Hour",
                                    bold: true,
                                    alignment: "right",
                                    fontSize: 9,
                                },
                                {
                                    width: 55,
                                    text: this.formatHour(totalHour),
                                    bold: true,
                                    alignment: "right",
                                    fontSize: 9,
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }

    // ================= CONTENT =================

    buildContent() {
        const clients = this.reportData?.clients || [];

        const result = [];

        clients.forEach((client, index) => {


            if (index !== 0) {
                result.push({
                    text: "",

                    pageBreak: "before",
                });
            }


            result.push(
                this.buildClientSection(client)
            );

            result.push(
                this.buildSummary(client)
            );
        });

        return result;
    }

    // ================= DOC =================

    buildDocDefinition() {
        return {
            pageSize: "A4",

            pageMargins: [35, 120, 35, 50],

            pageBreakBefore: (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) => {

                if (currentNode.id === "summary-section") {

                    const page =
                        currentNode.pageNumbers?.[0];

                    if (page && !this.summaryPages.includes(page)) {
                        this.summaryPages.push(page);
                    }
                }

                return false;
            },
            // ================= HEADER =================

            header: (currentPage) => {
                return this.buildPageHeader(currentPage);
            },

            // ================= FOOTER =================

            footer: (currentPage, pageCount) => {
                const isSummaryPage = this.summaryPages.includes(currentPage);

                return {
                    stack: [

                        {
                            canvas: [
                                ...(!isSummaryPage
                                    ? [
                                        // ================= LEFT TABLE =================
                                        {
                                            type: "line",

                                            x1: 35.5,
                                            y1: -671.9,

                                            x2: 35.5,
                                            y2: 0,

                                            lineWidth: 1,
                                        },
                                        // ================= ASSIGNMENT =================
                                        {
                                            type: "line",

                                            x1: 161.5,
                                            y1: -671.9,

                                            x2: 161.5,
                                            y2: 0,

                                            lineWidth: 1,
                                        },

                                        // ================= DATE =================
                                        {
                                            type: "line",

                                            x1: 237.5,
                                            y1: -671.9,

                                            x2: 237.5,
                                            y2: 0,

                                            lineWidth: 1,
                                        },

                                        // ================= CASE WORKER =================
                                        {
                                            type: "line",

                                            x1: 308.5,
                                            y1: -671.9,

                                            x2: 308.5,
                                            y2: 0,

                                            lineWidth: 1,
                                        },

                                        // ================= DETAILS =================
                                        {
                                            type: "line",

                                            x1: 514.5,
                                            y1: -671.9,

                                            x2: 514.5,
                                            y2: 0,

                                            lineWidth: 1,
                                        },

                                        // ================= RIGHT TABLE =================
                                        {
                                            type: "line",

                                            x1: 560.5,
                                            y1: -671.9,

                                            x2: 560.5,
                                            y2: 0,

                                            lineWidth: 1,
                                        },

                                        // ================= TOP FOOTER LINE =================
                                        {
                                            type: "line",
                                            x1: 35.5,
                                            y1: -0.5,
                                            x2: 560.5,
                                            y2: -0.5,
                                            lineWidth: 1,
                                        }
                                    ]
                                    : [])
                            ]
                        },
                        {
                            text: `Page ${currentPage} of ${pageCount}`,
                            alignment: "center",
                            fontSize: 8,
                            margin: [0, 5, 0, 0],
                        }
                    ]
                };
            },

            // ================= CONTENT =================

            content: this.buildContent(),

            // ================= DEFAULT =================

            defaultStyle: {
                font: "Sarabun",

                fontSize: 9,

                lineHeight: 1.15,
            },
        };
    }
}

export default new PDFTimesheetReport();